import React from "react";
import { useForm } from "react-hook-form";

import { stepperFormValidationMapper } from "@utilities";
import { getStep6Validations } from "../../Validations/step6";
import useFormStepControl from "@hooks/useFormStepControl";
import { ActionButtons } from "../../Components";
import { ClientBasicBusiness } from "./groups/ClientBasicBusiness";
import { ClientBasicBusinessIncome } from "./groups/ClientBasicBusinessIncome";

export const FormStep6 = React.memo(() => {
  const {
    formDraft,
    submitForm,
    isSent,
    handleActionButtonClick,
    submitType,
    validateForm
  } = useFormStepControl();

  const { handleSubmit, control, unregister } = useForm({
    resolver: (values, context) =>
      validateForm(values, context, () =>
        stepperFormValidationMapper(
          values,
          getStep6Validations({
            requiredBusinessLicense: values.clientProfile[0].data.requireBusinessLicense,
            requiredAmlRulesLeg: values.clientProfile[0].data.amlRulesLeg
          })
        )
      ),
    mode: "onSubmit",
    context: {
      submitType
    },
    shouldFocusError: true,
    defaultValues: formDraft.personData
  });

  const onSubmit = data => {
    submitForm(data, submitType);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ClientBasicBusiness control={control} unregister={unregister} />
        <ClientBasicBusinessIncome control={control} />
        <ActionButtons
          isLoading={isSent}
          handlePrevStep={handleActionButtonClick}
          handleNextStep={handleActionButtonClick}
        />
      </form>
    </>
  );
});
